import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {
    Icon,
    TextField,
    IconButton,
    Typography,
} from '@material-ui/core'
import {Link} from 'react-router-dom';
import ReduxGlobal from "../../store/actionreducers/globalView";
import PropTypes from "prop-types";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {FuseAnimate} from '@fuse';

class UecareListHeader extends Component {

    static propTypes = {
        arrowBack: PropTypes.object,
        icon: PropTypes.string,
        title: PropTypes.string,
    };

    render() {

        const {classes, setSearchText, searchText, reload} = this.props;
        return (
            <div className={classNames(classes.root, "flex flex-1 flex-col p-24")}>

                {
                    (!this.props.arrowBack) ? <div/> :
                        (
                            <div>
                                <FuseAnimate animation="transition.slideRightIn" delay={300}>
                                    <Typography className="normal-case flex items-center"
                                                component={Link}
                                                role="button"
                                                to={this.props.arrowBack.linkTo}>
                                        <Icon className="mr-4 text-20">arrow_back</Icon>
                                        {this.props.arrowBack.label}
                                    </Typography>
                                </FuseAnimate>
                                {reload && <IconButton onClick={reload}>
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <Icon className="text-32 mr-12">refresh</Icon>
                                    </FuseAnimate>
                                </IconButton>}
                            </div>

                        )
                }


                <div className={classNames(classes.root, "flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>

                    <div className="flex flex-1 lg:items-center items-end">

                        <div className="flex items-center">
                            <FuseAnimate animation="transition.expandIn" delay={300}>
                                <Icon className="text-32 mr-12">{this.props.icon}</Icon>
                            </FuseAnimate>
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <Typography variant="title">{this.props.title}</Typography>
                            </FuseAnimate>
                            {reload && <IconButton onClick={reload}>
                                <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                    <Icon className="text-32 mr-12">refresh</Icon>
                                </FuseAnimate>
                            </IconButton>}
                        </div>
                    </div>
                    <div className="flex lg:items-center items-start">

                        <FuseAnimate animation="transition.expandIn" delay={300}>
                            <Icon color="action">search</Icon>
                        </FuseAnimate>

                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                            <TextField
                              placeholder="搜尋"
                              className="pl-16"
                              fullWidth
                              value={searchText}
                              inputProps={{
                                  'aria-label': 'Search'
                              }}
                              onChange={setSearchText}
                            />
                        </FuseAnimate>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    root: {}
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSearchText: ReduxGlobal.ActionCreator.setSearchText
    }, dispatch);
}

function mapStateToProps({global: {searchText}}) {
    return {searchText};
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(UecareListHeader));



// WEBPACK FOOTER //
// ./src/components/header/UecareListHeader.js